export const ISSUES_FOR_POLISHING_REQUEST = "ISSUES_FOR_POLISHING_REQUEST";
export const ISSUES_FOR_POLISHING_SUCCESS = "ISSUES_FOR_POLISHING_SUCCESS";
export const ISSUES_FOR_POLISHING_FAILED = "ISSUES_FOR_POLISHING_FAILED";